<mat-card class="m-10 p-0">
  <mat-card-header class="titreFrm">
    <mat-card-title>Fiche Client</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border p-8 pt-16">
    <div class="flex justify-between col-span-2 w-1/2">
      <unilog-recherche
        class="w-full mr-4"
        appearance="outline"
        champsModel="Tiers_code"
        champsAffiche="Tiers_RS"
        [ServerSideFiltering]="true"
        textErreur="Veuillez Entrer un tier valide"
        [showError]="true"
        recherche="Tier"
        [api]="generalService.api"
        placeholder="Client"
        [(ngModel)]="client"
      >
      </unilog-recherche>
      <button
        mat-raised-button
        color="primary"
        class="afficherBtn"
        (click)="afficher()"
      >
        Afficher
      </button>
    </div>
    <ng-container *ngIf="clientData">
      <span class="text-2xl text-blue-800 font-bold py-4">{{
        clientData.Tiers_RS
      }}</span>
      <br />
      <div class="grid md:grid-cols-2 sm:grid-cols-1">
        <div class="flex">
          <label>Adresse :</label>
          <div>{{ clientData.Tiers_Adresse }}</div>
        </div>
        <div class="flex">
          <label>ville :</label>
          <div>{{ clientData.Tiers_Ville }}</div>
        </div>
        <div class="flex">
          <label>Pays :</label>
          <div>{{ clientData.Tiers_Pays }}</div>
        </div>
        <div class="flex">
          <label>Famille 1 :</label>
          <div>{{ clientData.Tiers_Famille }}</div>
        </div>

        <div class="flex">
          <label>civilité :</label>
          <div>{{ clientData.Tiers_Civilite }}</div>
        </div>
      </div>
      <span class="text-2xl text-gray-800 font-bold py-4">Contact</span>
      <div class="grid md:grid-cols-2 sm:grid-cols-1">
        <div class="flex">
          <label>Nom :</label>
          <div>{{ clientData.Tiers_RS }}</div>
        </div>
        <div class="flex">
          <label>Fonction :</label>
          <div>{{ clientData.Tiers_Contact_Fonction }}</div>
        </div>
        <div class="flex">
          <label>Tél :</label>
          <div>{{ clientData.Tiers_Contact_Tel }}</div>
        </div>
        <div class="flex">
          <label>Tél Mobile :</label>
          <div>{{ clientData.Tiers_Contact_Mobile }}</div>
        </div>
        <div class="flex">
          <label>Fax :</label>
          <div>{{ clientData.Tiers_Contact_Fax }}</div>
        </div>
        <div class="flex">
          <label>E-mail : </label>
          <div>{{ clientData.Tiers_Contact_mail }}</div>
        </div>
      </div>
      <span class="text-2xl text-gray-800 font-bold py-4">Finance</span>
      <div class="grid md:grid-cols-2 sm:grid-cols-1">
        <div class="flex">
          <label>Matricule fiscale :</label>
          <div>{{ clientData.Tiers_MF }}</div>
        </div>
        <div class="flex">
          <label>Matricule fiscale Cat :</label>
          <div>{{ clientData.Tiers_MFCat }}</div>
        </div>
        <div class="flex">
          <label>Matricule fiscale Clé :</label>
          <div>{{ clientData.Tiers_MFCle }}</div>
        </div>
        <div class="flex">
          <label>Matricule fiscale Etab :</label>
          <div>{{ clientData.Tiers_MFEtab }}</div>
        </div>
        <div class="flex">
          <label>RC ou CIN :</label>
          <div>{{ clientData.Tiers_RC }}</div>
        </div>
        <div class="flex">
          <label>Device</label>
          <div>{{ clientData.Devise_Code }}</div>
        </div>
        <div class="flex">
          <label>Tx TPF</label>
          <div>{{ clientData.Tiers_TxTPF1 }}</div>
        </div>
        <div class="flex">
          <label>Code TVA</label>
          <div>{{ clientData.Tiers_TVA }}</div>
        </div>
        <div class="flex">
          <label>Regime Fiscal</label>
          <div>{{ clientData.TiersRegime_Code }}</div>
        </div>
      </div>
      <span class="text-2xl text-gray-800 font-bold py-4">Banque</span>

      <div class="grid md:grid-cols-2 sm:grid-cols-1">
        <div class="flex">
          <label>Banque</label>
          <div>{{ clientData.Tiers_Banque }}</div>
        </div>
        <div class="flex">
          <label>RIB</label>
          <div>{{ clientData.Tiers_Banque_RIB }}</div>
        </div>
        <div class="flex">
          <label>Adresse</label>
          <div>{{ clientData.Tiers_Banque_Adresse }}</div>
        </div>
      </div>

      <span class="text-2xl text-gray-800 font-bold py-4">Gestion Encours</span>

      <div class="grid md:grid-cols-2 sm:grid-cols-1">
        <div class="flex">
          <label>Status</label>
          <div>{{ clientData.Tiers_ExoStatut }}</div>
        </div>
        <div class="flex">
          <label>Autorisé par</label>
          <div>{{ clientData.Tiers_AutorisePar }}</div>
        </div>
        <div class="flex">
          <label>Encours Autorisé</label>
          <div>{{ clientData.Tiers_EncoursStatus }}</div>
        </div>
        <div class="flex">
          <label>Encours Financier</label>
          <div></div>
        </div>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
